import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets.app/images/sign-up-google.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { onBeforeMount, onMounted, ref } from 'vue'

import { GoogleAuthView } from '@/models/auth/google'
import { AuthMode, type GoogleButtonLayout } from '@/models/auth/types'
import { GoogleNativeAuthView } from '@/models/auth/google.native'


export default /*@__PURE__*/_defineComponent({
  __name: 'GoogleSignInButton',
  props: {
    view: {},
    authMode: {},
    buttonLayout: { default: 'default' },
    showButton: { default: 'all' }
  },
  setup(__props: any) {

const props = __props

const isNativeApp = ref(false)
const bigContainerRef = ref<HTMLElement | null>(null)
const smallContainerRef = ref<HTMLElement | null>(null)

onBeforeMount(() => {
  isNativeApp.value = props.view instanceof GoogleNativeAuthView
})

onMounted(async () => {
  if (props.view instanceof GoogleAuthView) {
    await props.view.containerComponentHasMounted(
      props.authMode,
      props.buttonLayout,
      {
        big: bigContainerRef.value,
        small: smallContainerRef.value,
      },
    )
  }
})

/**
 * Start native Google auth when the custom mobile button is pressed.
 */
async function login(): Promise<void> {
  if (props.view instanceof GoogleNativeAuthView) {
    await props.view.start()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isNativeApp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            class: "button googleSignIn shortform-sign-up__button",
            onClick: login
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              class: "button__img",
              src: _imports_0,
              alt: ""
            }, null, -1),
            _createElementVNode("span", { class: "button__text d-none d-md-inline" }, "Sign up with Google", -1),
            _createElementVNode("span", { class: "button__text d-md-none" }, "Sign up with Google", -1)
          ]))])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.showButton === 'all' || __props.showButton === 'big')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref_key: "bigContainerRef",
                ref: bigContainerRef,
                class: "googleSigninBig"
              }, null, 512))
            : _createCommentVNode("", true),
          (__props.showButton === 'all' || __props.showButton === 'small')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                ref_key: "smallContainerRef",
                ref: smallContainerRef,
                class: "googleSigninSmall"
              }, null, 512))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})